import { AlertData } from "./data";

export function alertDataFromJson(json) {
  return new AlertData({
    id: json.id,
    categoryId: json.catId,
    title: json.alertWording,
    description: json.alertExplanation,
    active: json.active,
    lowerLimit: json.lower_limit,
    upperLimit: json.upper_limit,
    vesselId: json.vesselId,
    sendEmail: json.send_email,
    receiverEmail: json.receiver_email
  });
}
